
import React from 'react';
import { TableHead } from '@/components/ui/table';
import { ArrowUp, ArrowDown } from 'lucide-react';
import { cn } from '@/lib/utils';

export type SortField = 'name' | 'class' | 'contribution' | 'registeredAt' | 't_shirt_size';
export type SortDirection = 'asc' | 'desc';

interface SortableTableHeaderProps {
  field: SortField;
  label: string;
  currentSort: SortField;
  direction: SortDirection;
  onSort: (field: SortField) => void;
  className?: string;
}

const SortableTableHeader: React.FC<SortableTableHeaderProps> = ({
  field,
  label,
  currentSort,
  direction,
  onSort,
  className
}) => {
  const isActive = currentSort === field;
  
  return (
    <TableHead 
      className={cn(
        'cursor-pointer select-none text-muted-foreground hover:text-foreground transition-colors',
        isActive && 'text-foreground font-medium',
        className
      )}
      onClick={() => onSort(field)}
    >
      <div className="flex items-center">
        <span>{label}</span>
        
        <div className="ml-1 w-4 h-4 flex items-center justify-center">
          {isActive && (
            direction === 'asc' ? 
              <ArrowUp className="h-3 w-3" /> : 
              <ArrowDown className="h-3 w-3" />
          )}
        </div>
      </div>
    </TableHead>
  );
};

export default SortableTableHeader;
